import {
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardSubtitle,
  IonCardTitle,
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { updateLog } from "../lib/updateLog";

const UpdateLog: React.FC<{ dismissUpdate: () => void }> = ({
  dismissUpdate,
}) => {
  const { t } = useTranslation();
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>{t(`Updates`)}</IonTitle>
          <IonButtons slot="primary">
            <IonButton className="!font-semibold" onClick={dismissUpdate}>
              {t(`Done`)}
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent color="light" fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar color="light">
            <IonTitle size="large">{t(`Updates`)}</IonTitle>
          </IonToolbar>
        </IonHeader>
        <div className="flex flex-col items-center gap-4">
          {updateLog.map((log) => (
            <IonCard key={log.version} className="card-wrap max-w-md w-full">
              {log.cover && (
                <img
                  src={`/assets/images/updates/v-${log.version}.webp`}
                  alt="update cover"
                />
              )}
              <IonCardContent>
                <IonCardTitle>{log.version}</IonCardTitle>
                <IonCardSubtitle className="ion-padding-top ion-padding-bottom">
                  {log.date}
                </IonCardSubtitle>
                {log.body.map((b) => (
                  <p key={b}>{b}</p>
                ))}
              </IonCardContent>
            </IonCard>
          ))}
        </div>
      </IonContent>
    </IonPage>
  );
};

export default UpdateLog;
